import { Component, OnInit, ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import { EditModeService } from 'src/app/services/edit-mode/edit-mode.service';
import { Router, NavigationEnd } from '@angular/router';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { EditDialogService } from 'src/app/services/edit-dialog/edit-dialog.service';
import { TranslationSelectorService, I18nHelperService } from '@xref/ngx';
import { MatMenu } from '@angular/material/menu';
import {faCaretDown, faCaretUp, faAngleDown, faAngleUp} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'xqnr-header',
    templateUrl: './header.component.pug',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @ViewChild('languageSelector') languageSelector: MatMenu;

  isBuilderPage = false;

  fa = {
    caretDown: faCaretDown,
    caretUp: faCaretUp,
    angleDown: faAngleDown,
    angleUp: faAngleUp
  };

  showLanguageMenu = false;

  smallHeightScreen = false;

  constructor(
    public editMode: EditModeService,
    public location: Location,
    private router: Router,
    private editDialog: EditDialogService,
    private backdrop: BackdropService,
    public translationSelector: TranslationSelectorService,
    public i18nHelper: I18nHelperService
  ) {}

  ngOnInit(): void {
    this.setBuilderPageFlag(this.location.path());

    // Check for builder page when edit mode changes
    this.editMode.editModeChanged$.subscribe(() => {
      this.setBuilderPageFlag(this.location.path());
    });

    // Check for builder page when route changes
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd)
      this.setBuilderPageFlag(this.location.path());
    });
  }

  setBuilderPageFlag(url: string) {
    const path: number = url.toString().search('build');
    this.isBuilderPage = (path >= 0 ? true : false);
  }

  unlockEditClicked(event: any) {
    event.preventDefault();
    this.editDialog.show();
    this.backdrop.show();
  }
}
